import { Component, Ref, Prop, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import { cart } from "@/theme/Cart";
import { CartMain } from "../Cart/CartMain";
import { SideCart } from '../SideCart/SideCart';
import Swiper from 'swiper';

export interface SelectedProducts {
    id: number;
    quantity: number;
}

@Component
export class ShopTheLookBlock extends ThemeComponent {
    @Ref submitButton!: HTMLButtonElement[];
    @Ref submitBundle!: HTMLButtonElement[];
    @Ref productId!: number;

    protected loading: boolean = false;
    protected quantityVal: number = 1;
    private cartMain: CartMain = document.body.querySelector('cart-main') as CartMain;
    private sideCart: SideCart | null = document.body.querySelector('side-cart');


    private _onSwiperInit = new SimpleEvent<Swiper>();
    get onSwiperInit() {
        return this._onSwiperInit.asEvent();
    }

    // Map to store Swiper instances per look block
    swipers = new Map<HTMLElement, Swiper>();

    init() {

        window.onload = () => {
            this.sliderInitilize();
        };

        for (const button of this.submitButton) {
            this.$listen(button, 'click', async(e) => {
                e.preventDefault();
                const shopLookItem = button.closest('.product-card__footer');
                if (shopLookItem) {
                    const ids = shopLookItem
                        .querySelectorAll('input[type="hidden"]') as
                        NodeListOf<HTMLInputElement>;
                    await this.addToCartBundle(ids);
                }
            });
        }

        // Add event listener for submitBundle button
        for (const button of this.submitBundle) {
            this.$listen(button, 'click', async(e) => {
                e.preventDefault();
                // Find the closest shop-look__product-wrap to the submitBundle button
                const shopLookItem = button.closest('.shop-look-block__footer-right');
                if (shopLookItem) {
                    // Select all hidden input fields within the active popup
                    const ids = shopLookItem
                        .querySelectorAll('input[type="hidden"]') as
                        NodeListOf<HTMLInputElement>;
                    await this.addToCartBundle(ids);
                }
            });
        }


    }

    protected async addToCartBundle(ids: NodeListOf<HTMLInputElement>) {
        try {
            const idsToAdd: { id: number; quantity: number }[] = [];
            const cartCheck: { id: number; inCart: boolean }[] = [];
            for (const [i, id] of ids.entries()) {
                const idUse = parseInt(id.value, 10);
                const itemInCart: boolean = cart.checkCart(idUse);
                const addString = { id: idUse, quantity: 1};
                const checkString = { id: idUse, inCart: itemInCart };
                cartCheck.push(checkString);
                idsToAdd.push(addString);
            }

            await cart.addItems(idsToAdd)
                .then(() => {
                    document.dispatchEvent(new Event('cartChanged'));
                })
                .catch((error: unknown) => {
                    this.$log.error('Cart error', { error });
                });
        } catch (error) {
            this.$log.error('Unexpected cart error', { error });
        }
    }

    private sliderInitilize() {
        const sliders = document.querySelectorAll<HTMLElement>('.product-slider-js');
        for (const slider of sliders) {
            const parentDiv = slider.closest('.shop-content-js') as HTMLElement;
            if (parentDiv) {
                let swiperInstance = this.swipers.get(slider);

                // Initialize Swiper if not already initialized
                if (!swiperInstance) {
                    swiperInstance = new Swiper(slider, {
                        navigation: {
                            nextEl: parentDiv.querySelector('.swiper-next') as HTMLElement,
                            prevEl: parentDiv.querySelector('.swiper-prev') as HTMLElement,
                        },
                        pagination: true,
                        slidesPerView: 1.15,
                        spaceBetween: 8,
                        speed: 300,
                        breakpoints: {
                            425: {
                                slidesPerView: 1.5,
                                spaceBetween: 12,
                            },
                            768: {
                                slidesPerView: 1,
                                spaceBetween: 64,
                            },
                        },
                    });

                    this.swipers.set(slider, swiperInstance);
                    this._onSwiperInit.dispatch(swiperInstance); // Emit the Swiper instance

                    swiperInstance.on('init', () => {
                        if (swiperInstance) {
                            this.updateNavigationButtons(swiperInstance, parentDiv);
                        }
                    });

                    // Ensure navigation buttons reflect current state
                    this.updateNavigationButtons(swiperInstance, parentDiv);
                }
            }
        }
    }

    updateNavigationButtons(swiperInstance: Swiper, parentDiv: HTMLElement) {
        const prevButton = parentDiv.querySelector('.swiper-prev') as HTMLButtonElement;
        const nextButton = parentDiv.querySelector('.swiper-next') as HTMLButtonElement;

        if (prevButton) {
            if (swiperInstance.isBeginning) {
                prevButton.classList.add('swiper-button-disabled');
                prevButton.disabled = true;
            } else {
                prevButton.classList.remove('swiper-button-disabled');
                prevButton.disabled = false;
            }
        }

        if (nextButton) {
            if (swiperInstance.isEnd) {
                nextButton.classList.add('swiper-button-disabled');
                nextButton.disabled = true;
            } else {
                nextButton.classList.remove('swiper-button-disabled');
                nextButton.disabled = false;
            }
        }
    }

}
